<mat-sidenav-container class="minFullHeight ">
    <mat-sidenav (closed)="sideNav = false" [mode]="mode" [opened]="sideNav">
        <nav aria-label="Main menu">
            <mat-nav-list class="p-0">
                @if (this.timelineId) {
                    <a [routerLinkActive]="['mat-background-primary', 'primaryContrast']"
                       [routerLink]="['/timeline']"
                       class="align-items-center"
                       disableRipple mat-list-item>
                        <mat-icon class="pr-10" matListItemIcon>
                            <img alt="Virtual Memory Box Logo" height="24" ngSrc="assets/images/vmb.svg" width="24">
                        </mat-icon>
                        <div matListItemTitle>Memory Box</div>
                    </a>
                }

                @if (hasContactEmail) {
                    <button (click)="openHelp()" class="align-items-center" disableRipple mat-list-item type="button">
                        <mat-icon class="pr-10" matListItemIcon>help_outline</mat-icon>
                        <div matListItemTitle>Help</div>
                    </button>
                }

                @if (this.user && this.user.role.role_type === 'admin') {
                    <a [routerLinkActive]="['mat-background-primary', 'primaryContrast']"
                       [routerLink]="['/users']"
                       class="align-items-center"
                       disableRipple mat-list-item>
                        <mat-icon class="pr-10" matListItemIcon>security</mat-icon>
                        <div matListItemTitle>Return to Admin Dashboard</div>
                    </a>
                }
                <button (click)="openNotificationNav()" [attr.aria-expanded]="notificationNavOpened"
                        aria-controls="notificationPanel"
                        class="align-items-center"
                        disableRipple
                        mat-list-item type="button">
                    <mat-icon class="pr-10 notification-count-badge" matListItemIcon
                              [matBadgeHidden]="!notificationsCount || notificationsCount == '0'"
                              [matBadge]="notificationsCount" matBadgeColor="warn"
                              matBadgePosition="after" matBadgeSize="small">notifications</mat-icon>
                    <div matListItemTitle>Notifications</div>
                </button>
                <a [routerLinkActive]="['mat-background-primary', 'primaryContrast']" [routerLink]="['/people']"
                   class="align-items-center"
                   disableRipple mat-list-item>
                    <mat-icon class="pr-10 customIcon" matListItemIcon
                              svgIcon="boxIcon"></mat-icon>
                    <div matListItemTitle>Memory Boxes</div>
                </a>

                @if (this.timelineId && !this.isRaa) {
                    <a [routerLinkActive]="['mat-background-primary', 'primaryContrast']"
                       [routerLink]="['/favourites']"
                       class="align-items-center"
                       disableRipple mat-list-item>
                        <mat-icon class="pr-10 customIcon" matListItemIcon>favorite</mat-icon>
                        <div matListItemTitle>Favourites</div>
                    </a>
                }

                @if (showTrainingCentre) {
                    <mat-expansion-panel class="dropdownMenuItem mat-elevation-z0" hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon class="pr-10" matListItemIcon>school</mat-icon>
                                Training Centre
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        @if (this.user.role.role_type !== 'admin') {
                            <a [routerLink]="['/videoGuides']" class="align-items-center" disableRipple mat-list-item>
                                <div matListItemTitle>Video Guides</div>
                            </a>
                            <a [routerLink]="['/faqs']" class="align-items-center" disableRipple mat-list-item>
                                <div matListItemTitle>FAQs</div>
                            </a>

                            <!--                <mat-list-item [routerLink]="['/resources']" class="align-items-center" disableRipple>-->
                                    <!--                    <div matListItemTitle>Resources</div>-->
                                    <!--                </a>-->
                            <a [routerLink]="['/writtenGuides']" class="align-items-center" disableRipple mat-list-item>
                                <div matListItemTitle>Written Guides</div>
                            </a>
                        }
                        @if (canBookTrainingSession) {
                            <button (click)="openHelp(true)" class="align-items-center" disableRipple
                                    mat-list-item type="button">
                                <div matListItemTitle>Book a Training Session</div>
                            </button>
                        }
                    </mat-expansion-panel>
                }
                @if (this.user && this.user.role.role_type !== 'admin') {
                    <a [routerLinkActive]="['mat-background-primary', 'primaryContrast']" [routerLink]="['/settings']"
                       class="align-items-center"
                       disableRipple mat-list-item>
                        <mat-icon class="pr-10" matListItemIcon>settings</mat-icon>
                        <div matListItemTitle>Settings</div>
                    </a>
                }
                <button (click)="logout()" class="align-items-center" disableRipple mat-list-item type="button">
                    <mat-icon class="pr-10" matListItemIcon>exit_to_app</mat-icon>
                    <div matListItemTitle>Log-out</div>
                </button>
            </mat-nav-list>
        </nav>
    </mat-sidenav>
    <mat-sidenav (closed)="notificationNavOpened = false;" [opened]="notificationNavOpened" class="alertMenu p-10"
                 [fixedInViewport]="true" id="notificationPanel" mode="over" position="end">
        <div class="flex-row d-flex flex-space-between">
            <button (click)="notificationNavOpened = false;" aria-label="Close notifications"
                    mat-icon-button>
                <mat-icon aria-hidden="true">close</mat-icon>
            </button>
        </div>
        @defer (when notificationNavOpened) {
            <app-notification-sidebar (getCount)="this.getNotificationCount()"
                                      [getNotifications]="this.notificationNavOpened">
            </app-notification-sidebar>
        } @loading (after 200ms) {
            <div class="flex-row justify-content-center mt-5 w-100">
                <mat-progress-spinner aria-label="Loading notifications"
                                      mode="indeterminate"></mat-progress-spinner>
            </div>
        }

    </mat-sidenav>
    <mat-sidenav-content autosize>
        <a class="skip-link" href="#mainContent">Skip to main content</a>
        @if (hijacking) {
            <div class="hijackBar">
                <p>You are viewing the VMB platform as {{ user | nameDisplay }} </p>
                <button (click)="logout()" (keyup.enter)="logout()" aria-label="Log Out" mat-icon-button
                        matTooltip="Log Out">
                    <mat-icon>exit_to_app</mat-icon>
                </button>
            </div>
        }
        @if (this.user) {
            <mat-toolbar class="d-flex flex-space-between mat-elevation-z3" color="primary" role="banner">
                <!--Will be child or adult or admin in prod-->
                <div class="flex-row align-items-center">
                    <button [routerLink]="[this.timelineId ? '/timeline' : '/people']"
                            aria-label="Home" id="home"
                            mat-icon-button matTooltip="Home">
                        <img alt="Virtual Memory Box Logo" height="24" ngSrc="assets/images/vmb.svg" width="24">
                    </button>

                    <p class="m-0 greeting">{{ user | nameDisplay: undefined: undefined: 'nav' | greeting }}</p>
                </div>
                @if (!isMobile) {
                    <nav aria-label="Primary">
                        @if (hasContactEmail) {
                            <button (click)="openHelp()" (keyup.enter)="openHelp()"
                                    aria-label="Help"
                                    mat-icon-button matTooltip="Help">
                                <mat-icon [routerLinkActive]="'mat-accent'">help_outline</mat-icon>
                            </button>
                        }
                        @if (this.user.role.role_type === 'admin') {
                            <button [routerLink]="['/users']"
                                    aria-label="Return to Admin Dashboard" mat-icon-button
                                    matTooltip="Return to Admin Dashboard">
                                <mat-icon [routerLinkActive]="'mat-accent'">security</mat-icon>
                            </button>
                        }
                        <button (click)="openNotificationNav()"
                                [attr.aria-expanded]="notificationNavOpened"
                                [attr.aria-label]="notificationsCount && notificationsCount != '0' ? 'Notifications, ' + notificationsCount + ' unread' : 'Notifications'"
                                [matBadgeHidden]="!notificationsCount || notificationsCount == '0'"
                                [matBadge]="notificationsCount"
                                aria-controls="notificationPanel"
                                class="notification-count-badge" mat-icon-button matBadgeColor="warn"
                                matBadgePosition="after" matBadgeSize="small" matTooltip="Notifications">
                            <mat-icon [routerLinkActive]="'mat-accent'">notifications</mat-icon>
                        </button>
                        <button [routerLink]="['/people']" aria-label="View People"
                                mat-icon-button
                                matTooltip="Memory Boxes">
                            <mat-icon [routerLinkActive]="'mat-accent'" class="customIcon" svgIcon="boxIcon"></mat-icon>
                        </button>
                        @if (this.timelineId && !this.isRaa) {
                            <button [routerLink]="['/favourites']"
                                    aria-label="Favourites"
                                    mat-icon-button
                                    matTooltip="My favourite memories">
                                <mat-icon [routerLinkActive]="'mat-accent'">favorite</mat-icon>
                            </button>
                        }
                        @if (showTrainingCentre) {
                            <button [matMenuTriggerFor]="training"
                                    aria-label="Training Centre"
                                    mat-icon-button
                                    matTooltip="Training Centre">
                                <mat-icon [routerLinkActive]="'mat-accent'">school</mat-icon>
                            </button>
                        }
                        <mat-menu #training="matMenu">
                            <button [routerLink]="['/videoGuides']" mat-menu-item>Video Guides</button>
                            @if (this.user.role.role_type !== 'admin') {
                                <button [routerLink]="['/faqs']" mat-menu-item>FAQs</button>
                                <!--                    <button mat-menu-item [routerLink]="['/resources']">Resources</button>-->
                                <button [routerLink]="['/writtenGuides']" mat-menu-item>Written Guides</button>
                            }
                            @if (canBookTrainingSession) {
                                <button (click)="openHelp(true)" (keyup.enter)="openHelp(true)" mat-menu-item>Book a
                                    Training Session
                                </button>
                            }
                        </mat-menu>
                        @if (this.user && this.user.role.role_type !== 'admin') {
                            <button [routerLink]="['/settings']" aria-label="Settings"
                                    mat-icon-button
                                    matTooltip="Settings">
                                <mat-icon [routerLinkActive]="'mat-accent'">settings</mat-icon>
                            </button>
                        }
                        <button (click)="logout()" (keyup.enter)="logout()" aria-label="Log Out" mat-icon-button
                                matTooltip="Log Out">
                            <mat-icon>exit_to_app</mat-icon>
                        </button>
                    </nav>
                }
                @if (isMobile) {
                    <button (click)="sideNav = !sideNav" (keyup.enter)="sideNav = !sideNav"
                            aria-label="Open Side Menu" mat-icon-button>
                        <mat-icon>menu</mat-icon>
                    </button>
                }
            </mat-toolbar>
        }
        <main class="minFullHeight" id="mainContent" tabindex="-1">
            @defer () {
                <app-alert-banner width="80%"/>
            }
            <router-outlet (activate)="sideNav = false"></router-outlet>
        </main>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
